import { render, staticRenderFns } from "./VideoWall.vue?vue&type=template&id=57171be6&scoped=true"
import script from "./VideoWall.vue?vue&type=script&lang=js"
export * from "./VideoWall.vue?vue&type=script&lang=js"
import style0 from "./VideoWall.vue?vue&type=style&index=0&id=57171be6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57171be6",
  null
  
)

export default component.exports